export default class MenuScreen {
  constructor({ onPlay, onDaily }) {
    this.onPlay = onPlay;
    this.onDaily = onDaily;

    this.highscoreEl = document.getElementById('menu-highscore');
    this.dailyHintEl = document.getElementById('menu-daily-hint');

    document.getElementById('btn-play')?.addEventListener('click', () => this.onPlay?.());
    document.getElementById('btn-daily')?.addEventListener('click', () => this.onDaily?.());
  }

  setHighScore(score) {
    if (!this.highscoreEl) return;
    const n = Math.floor(Number(score) || 0);
    this.highscoreEl.textContent = n > 0
      ? `HIGH SCORE · ${n}`
      : 'HIGH SCORE · —';
  }

  setDailyHint(songTitle, dateKey) {
    if (!this.dailyHintEl) return;
    const title = String(songTitle ?? '').replace(/<[^>]*>/g, '').slice(0, 64);
    const key = String(dateKey ?? '').replace(/[^\d-]/g, '').slice(0, 16);
    this.dailyHintEl.textContent = `${key} · ${title}`;
  }
}
